// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiAuthFirebase: `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDm9Kmf-F2-hQL5QrwtwI--9LKHz4U64Mo`,
  apiAuthLogin: 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDm9Kmf-F2-hQL5QrwtwI--9LKHz4U64Mo',
  fireBase: 'https://auth-59b16.firebaseio.com/',
  // express: 'http://localhost:5000/',
  express: 'https://adorable-hem-cow.cyclic.app/',
  local: 'http://localhost:5000/',
  githubcodespace: 'https://adorable-hem-cow.cyclic.app/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
